import { render, staticRenderFns } from "./ResourcesMonitoringSingle.vue?vue&type=template&id=f0d4ffee&"
import script from "./ResourcesMonitoringSingle.vue?vue&type=script&lang=js&"
export * from "./ResourcesMonitoringSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports